import { useEffect, useState } from 'react';
import axios from 'axios';
import moment from 'moment';
import { BASE_URL } from "../config";
import Select from "react-tailwindcss-select";
import Skeleton from 'react-loading-skeleton';
import { useNavigate } from "react-router-dom";
import fireIcon from '../../src/assets/images/fireIcon.svg'
import clockIcon from '../../src/assets/images/clockIcon.svg'
import fitbitlogo from '../../src/assets/images/fitbitlogo.svg'
import garminlogo from '../../src/assets/images/garminlogo.svg'
import whiteDownArrow from '../../src/assets/images/whiteDownArrow.svg'
import { data } from 'autoprefixer';
import authStorage from "../utils/authStorage";


const daysInMonth = (month, year) => {
  return new Date(year, month, 0).getDate();
};

const getMonthName = (month) => {
  const monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  const current_year = new Date().getFullYear();

  if (month == 0) {
    return monthNames[11] + " " + (current_year - 1);
  }
  else if (month < 0) {
    return monthNames[10] + " " + (current_year - 1);
  } else {
    return monthNames[month - 1];
  }
};

const Calendar = ({ back }) => {
  const [currentMonth, setCurrentMonth] = useState(new Date().getMonth() + 1);
  const [currentMo, setCurrentMo] = useState(new Date().getMonth() + 1);
  const [monVal, setMonVal] = useState(new Date().getMonth() + 1);
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());
  const [calendarEvents, setCalendarEvents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [device, setDevice] = useState('FitBit');
  const [deviceStatus, setDeviceStatus] = useState('');
  // const [dayy, setDayy] = useState("THU");
  const [dayy, setDayy] = useState(() => {
    const days = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];
    const date = new Date();
    const firstDayOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
    const firstDay = firstDayOfMonth.getDay();
    return days[firstDay];
  });
  const [garConnect, setGarConnect] = useState(false);
  const [fitConnect, setFitConnect] = useState(false);
  const [appleConnected, setAppleConnected] = useState(false);
  const [gartokConnect, setGartokConnect] = useState(false);
  const [walkThroughPending, setWalkThroughPending] = useState(JSON.parse(authStorage.getItem("walkthrough")?.walkThroughPending ?? false).walkThroughPending);
  const [walkThroughSteps, setWalkThroughSteps] = useState(JSON.parse(authStorage.getItem("walkthrough")?.walkThroughPending ?? false).walkThroughSteps);
  const navigate = useNavigate();
  const handlePreviousMonth = (month) => {
    toggleOptionBox();

    let newMonth, newYear;

    if (month == 0) {
      newYear = new Date().getFullYear() - 1;
      newMonth = 12;
    } else if (month == -1) {
      newYear = new Date().getFullYear() - 1;
      newMonth = 11;
    } else if (month == -2) {
      newYear = new Date().getFullYear() - 1;
      newMonth = 10;
    } else {
      newMonth = month;
      newYear = new Date().getFullYear();
    }

    setCurrentYear(newYear);
    setCurrentMonth(newMonth);
    setDayy(firstDayOfMonth(month));
  };

  const handleNextMonth = () => {
    if (currentMonth === 12) {
      setCurrentMonth(1);
      setCurrentYear(currentYear + 1);
    } else {
      setCurrentMonth(currentMonth + 1);
    }
  };

  const handlePreviousYear = () => {
    setCurrentYear(currentYear - 1);
  };

  const handleNextYear = () => {
    setCurrentYear(currentYear + 1);
  };

  const monthDays = daysInMonth(currentMonth, currentYear);
  const firstDay = new Date(currentYear, currentMonth - 1, 1).getDay();
  const weeks = Math.ceil((monthDays + firstDay) / 7);

  const days = [];
  for (let i = 1; i <= weeks * 7; i++) {
    if (i > firstDay && i <= monthDays + firstDay) {
      days.push(i - firstDay);
    } else {
      days.push(null);
    }
  }

  const getCalendartList = (overrideMonth, overrideYear) => {
    const month = overrideMonth ?? currentMonth;
    const year = overrideYear ?? currentYear;
    let selectedStartDate = moment(`${year}-${month}-01`).startOf('month').format('YYYY-MM-DD');
    let selectedEndDate = moment(`${year}-${month}-01`).endOf('month').format('YYYY-MM-DD');
    let userId = authStorage.getItem("userId");
    setLoading(true);

    let url = '';
    if (device === "FitBit") {
      url = `${BASE_URL}/user/getfitbitexercisedata/${selectedStartDate}/${selectedEndDate}`;
    } else if (device === 'Garmin') {
      url = `${BASE_URL}/user/getgarminexercisedatabydate/${selectedStartDate}/${selectedEndDate}`;
    } else if (device === 'Apple') {
      url = `${BASE_URL}/apple/getapplehealthdatabydate/${selectedStartDate}/${selectedEndDate}/${userId}`;
    }

    axios({
      headers: {
        "x-access-token": authStorage.getItem("auth-token")
      },
      url,
      method: 'GET'
    }).then((res) => {
      setLoading(false);
      let newData = {};

      res?.data?.data?.map((data) => {
        // Key by full date string "2026-03-04" to avoid day-number collisions
        let dateKey = data?.onDateTime?.split('T')[0];

        // Apply 2x AZM only for Fitbit
        if (device === "FitBit") {
          const zonesWithAZM = data?.heartRateZones?.map((zone) => {
            let multiplier = 0;
            switch (zone.heartZoneName?.toLowerCase()) {
              case "light": multiplier = 1; break;  // Fat Burn → 1x
              case "moderate": multiplier = 2; break;  // Cardio → 2x Zone data
              case "vigorous": multiplier = 2; break;  // Peak → 2x Zone data
              default: multiplier = 0;
            }

            return {
              ...zone,
              minutes: zone.minutes * multiplier,       // AZM (Activity Zone Minutes) minutes
              rawMinutes: zone.minutes,                  // Keep original
            };
          });
          newData[dateKey] = zonesWithAZM;
        } else {
          // Garmin & Apple — no change
          newData[dateKey] = data?.heartRateZones;
        }
      });
      setCalendarEvents(newData);

    }).catch((err) => {
      setLoading(false);
    });
  };

  const getDeviceStatus = () => {
    axios({
      headers: {
        "x-access-token": authStorage.getItem("auth-token"),
      },
      url: `${BASE_URL}/user/device/status`, //your url
      method: "GET",
    }).then((res) => {
      setDeviceStatus(res.data);
    });
  };

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
    getDeviceStatus();
  }, []);

  useEffect(() => {
    setCalendarEvents({});
    setLoading(true);
    getCalendartList(currentMonth, currentYear);
  }, [currentYear, currentMonth, device]);

  useEffect(() => {
    let isFitbitConnected = deviceStatus?.isFitbitConnected;
    let isGarminConnected = deviceStatus?.isGarminConnected;
    let isAppleConnected = deviceStatus?.isAppleConnected;
    if (isFitbitConnected) {
      setDevice('FitBit');
    } else if (isGarminConnected) {
      setDevice('Garmin');
    } else if (isAppleConnected) {
      setDevice('Apple');
    } else {
      setDevice('FitBit');
    }
  }, [deviceStatus]);

  const handleChange = (value) => {
    setDevice(value);
  };
  useEffect(() => {
    let userStatus = authStorage.getItem('status');
    let subscribedStatus = authStorage.getItem('subscribedStatus');


    if (subscribedStatus == 'false' && userStatus != 2) {
      window.location = window.location.origin + '/membership';
      return false;
    } else if (fitConnect == 'false' && garConnect == 'false' && appleConnected == 'false') {
      navigate('/device');
      back(0);
    }

  });
  useEffect(() => {
    const getDeviceStatus = async () => {
      console.log("fff : ", fitConnect, garConnect)
      try {
        const res = await axios({
          headers: {
            "x-access-token": authStorage.getItem("auth-token"),
          },
          url: `${BASE_URL}/user/device/status`,
          method: "GET",
        });
        setGarConnect(res.data.isGarminConnected);
        setFitConnect(res.data.isFitbitConnected);
        setAppleConnected(res.data.isAppleConnected);
        setGartokConnect(res.data.isGarminConnectedthroughtoken);
        // console.log("fff g: ",fitConnect,garConnect,res.data.isGarminConnected,res.data.isFitbitConnected)
        if (!res.data.isGarminConnected && !res.data.isFitbitConnected && !res.data.isAppleConnected) {

          navigate('/device'); back(0);
        }

      } catch (err) {
        if (err.code === "ERR_BAD_REQUEST") {

        }
      }
    };

    getDeviceStatus();
  }, []);



  const [isOptionBoxVisible, setIsOptionBoxVisible] = useState(false);
  const toggleOptionBox = () => {
    setIsOptionBoxVisible(!isOptionBoxVisible);
  };
  function firstDayOfMonth(currentMonth) {
    const date = new Date(new Date().getFullYear(), currentMonth - 1, 1);
    return date.toLocaleDateString('en-US', { weekday: 'short' }).toUpperCase();
  }


  function printDaysOfWeek(firstDay) {
    const days = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];
    const index = days.indexOf(firstDay);
    if (index === -1) {
      throw new Error("Invalid first day of the week");
    }

    const rearrangedDays = [...days.slice(index), ...days.slice(0, index)];
    return rearrangedDays.map((day, i) => {
      return (
        <div
          key={i}
          className={`bg-[#202223] w-[33.3%] md:w-[14.1867%] p-4 uppercase ${i === 0 ? "rounded-tl-lg" : i === 6 ? "rounded-tr-lg" : ""
            }`}
        >
          {day}
        </div>
      );
    });
  }
  return (
    <div className="justify-center md:p-5 px-3 py-5">
      <div className="bg-white md:p-4 p-0">
        <h2 className="mob-header font-medium mb-5 p-2 pt-4 md:p-0 md:pt-0">Dashboard</h2>


        {loading ? (
          <>
            <div className="hidden md:block mx-2">
              <Skeleton baseColor="#ccc" highlightColor="#fff" height={60} width={'100%'} className="mx-0 mb-4" />
            </div>
            <div className="md:hidden m-1">
              <Skeleton baseColor="#ccc" highlightColor="#fff" height={60} />
            </div>
          </>
        ) : (
          <div className="flex justify-between items-center bg-[#E53E14] rounded md:px-4 px-2 text-white w-[99.4%] mb-5">
            <div className="flex items-center justify-between md:gap-5 gap-1">
              <div className='md:text-base text-xs'>Select Device: </div>
              <div className={`py-3 px-2 xl:py-4 xl:px-6 hover:bg-[#FF481A] transition duration-700 ease-out cursor-pointer mb-1 text-center uppercase md:text-base text-xs ${fitConnect ? `` : `pointer-events-none cursor-not-allowed`} ${device == 'FitBit' ? `bg-[#FF481A] border-0 border-b-[2px] xl:border-b-[2px] border-solid border-white ` : ``}`} onClick={() => handleChange('FitBit')} ><img src={fitbitlogo} alt="Icon" className='align-middle mr-2 md:mb-0 mb-1' /> Fitbit</div>
              <div className={`py-3 px-2 xl:py-4 xl:px-6 hover:bg-[#FF481A] transition duration-700 ease-out cursor-pointer mb-1 text-center uppercase md:text-base text-xs ${garConnect ? `` : `pointer-events-none cursor-not-allowed`} ${device == 'Garmin' ? `bg-[#FF481A] border-0 border-b-[2px] border-solid border-white ` : ``}`} onClick={() => handleChange('Garmin')}><img src={garminlogo} alt="Icon" className='align-middle mr-2 md:mb-0 mb-1' /> Garmin</div>
              <div className={`py-3 px-2 xl:py-4 xl:px-6 hover:bg-[#FF481A] transition duration-700 ease-out cursor-pointer mb-1 text-center uppercase md:text-base text-xs ${appleConnected ? `` : `pointer-events-none cursor-not-allowed`} ${device == 'Apple' ? `bg-[#FF481A] border-0 border-b-[2px] border-solid border-white ` : ``}`} onClick={() => handleChange('Apple')}><img src={garminlogo} alt="Icon" className='align-middle mr-2 md:mb-0 mb-1' /> Apple</div>

            </div>
            <div className='flex items-center justify-between relative'>
              <div className='md:text-base text-xs text-center md:text-left'>
                Month: <span className='whitespace-nowrap cursor-pointer ml-1 font-semibold' onClick={toggleOptionBox}>{getMonthName(currentMonth)}
                  <img src={whiteDownArrow} alt="Icon" className='ml-2' />
                </span>
              </div>
              {isOptionBoxVisible && (
                <div className='absolute bg-[#E53E14] px-5 py-4 top-10 right-0 md:w-40 w-20 flex md:gap-5 gap-2 flex-col rounded'>
                  <div className='cursor-pointer hover:font-semibold md:text-base text-xs' onClick={() => { handlePreviousMonth(currentMo) }} >{getMonthName(currentMo)}</div>
                  <div className='cursor-pointer hover:font-semibold md:text-base text-xs' onClick={() => { handlePreviousMonth(currentMo - 1) }}>{getMonthName(currentMo - 1)}</div>
                  <div className='cursor-pointer hover:font-semibold md:text-base text-xs' onClick={() => { handlePreviousMonth(currentMo - 2) }}>{getMonthName(currentMo - 2)}</div>
                </div>
              )}
            </div>
          </div>
        )}


        <div className="flex text-white rounded text-center hidden md:flex">
          {printDaysOfWeek(dayy)}
        </div>
        <div className="flex flex-wrap">
          {days.map((day, index) => {
            let currentFullDate = `${currentYear}-${currentMonth?.toString().padStart(2, "0")}-${day?.toString().padStart(2, "0")}`;

            let isCurrentDate =
              day === new Date().getDate() &&
              currentMonth === new Date().getMonth() + 1 &&
              currentYear === new Date().getFullYear();
            let currentHeartData = {};
            calendarEvents?.[currentFullDate]?.forEach(data => {
              currentHeartData[data?.heartZoneName?.toLowerCase() || 'unknown'] = data;
            });
            if (!day) {
              return '';
            }
            return (

              <div
                key={index}
                className={`w-[33.3%] md:w-[14.1867%] text-xs max-[1600px]:text-smtext-sm text-gray-500 text-center border border-solid border-[#3635381c] bg-[#F9F9F9] p-0 md:p-2 ${!day ? "" : ""}`}
              >
                {loading ? (
                  <>
                    <div className="hidden md:block mx-2">
                      <Skeleton baseColor="#ccc" highlightColor="#fff" height={60} width={'100%'} className="m-2" />
                      <Skeleton baseColor="#ccc" highlightColor="#fff" height={60} width={'100%'} className="m-2" />
                    </div>
                    <div className="md:hidden m-1">
                      <Skeleton baseColor="#ccc" highlightColor="#fff" height={60} />
                      <Skeleton baseColor="#ccc" highlightColor="#fff" height={60} />
                    </div>
                  </>
                ) : (
                  <div className="m-1 w-50">
                    <div className="w-full">
                      <div
                        className={`flex flex-col ${isCurrentDate
                          ? "text-white bg-[#8451dd]"
                          : "text-[#363538] font-medium"
                          } justify-center md:p-1 md:px-2 p-0 mb-2 hover:text-white hover:bg-[#9c27b0] scale-box`}
                      >
                        <div className="flex md:justify-end justify-center text-md uppercase md:hidden block bg-[#202223] text-white p-2 rounded mb-1">
                          {moment(currentFullDate).format('ddd')}
                        </div>
                        <div className="flex md:justify-end justify-center md:text-lg text-base">
                          {day}
                        </div>
                      </div>
                      <div className="border-0 border-l-4 border-solid border-[#0694F3] bg-[#C3E1F3] hover:bg-[#279fef] hover:text-white scale-box p-2 text-[#272727] mb-2">
                        <div className="flex flex-wrap justify-between rounded">
                          <div className="flex items-center gap-[4px] text-md font-medium w-[40px] xl:justify-start justify-between">
                            <img src={clockIcon} alt="Icon" />
                            {Math.ceil(Number(currentHeartData?.light?.minutes || 0))}
                          </div>
                          <div className="flex items-center gap-[4px] text-md font-medium w-[40px] xl:justify-start justify-between">
                            <img src={fireIcon} alt="Icon" />
                            {currentHeartData?.light?.caloriesOut?.toFixed() || 0}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="w-full">
                      <div className="border-0 border-l-4 border-solid border-[#FF8B20] bg-[#FFD7B2] hover:bg-[#f76700] hover:text-white scale-box p-2 text-[#272727] mb-2">
                        <div className="flex flex-wrap justify-between rounded">
                          {/* <span className="hidden md:block">Vigorous</span> */}
                          <div className="flex items-center gap-[4px] text-md font-medium w-[40px] xl:justify-start justify-between">
                            <img src={clockIcon} alt="Icon" />
                            {device === "FitBit" ? (
                              <div style={{ display: "flex", gap: "4px" }}>
                                {Math.ceil(Number(currentHeartData?.moderate?.minutes || 0))}
                                <span style={{ fontStyle: "italic", fontSize: "9px", color: "#045904" }}>AZM</span>
                              </div>
                            ) : (
                              Math.ceil(Number(currentHeartData?.moderate?.minutes || 0))
                            )}
                          </div>
                          <div className="flex items-center gap-[4px] text-md font-medium w-[40px] xl:justify-start justify-between">
                            <img src={fireIcon} alt="Icon" />
                            {currentHeartData?.moderate?.caloriesOut?.toFixed() || 0}
                          </div>
                        </div>
                      </div>
                      <div className="border-0 border-l-4 border-solid border-[#F50F51] bg-[#FFD7E2] hover:bg-[#ff2863] hover:text-white scale-box p-2 text-[#272727] mb-2">
                        <div className="flex flex-wrap justify-between rounded">
                          <div className="flex items-center gap-[4px] text-md font-medium w-[40px] xl:justify-start justify-between">
                            <img src={clockIcon} alt="Icon" />
                            {device === "FitBit" ? (
                              <div style={{ display: "flex", gap: "4px" }}>
                                {Math.ceil(Number(currentHeartData?.vigorous?.minutes || 0))}
                                <span style={{ fontStyle: "italic", fontSize: "9px", color: "#045904" }}>AZM</span>
                              </div>
                            ) : (
                              Math.ceil(Number(currentHeartData?.vigorous?.minutes || 0))
                            )}
                          </div>
                          <div className="flex items-center gap-[4px] text-md font-medium w-[40px] xl:justify-start justify-between">
                            <img src={fireIcon} alt="Icon" />
                            {currentHeartData?.vigorous?.caloriesOut?.toFixed() || 0}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )
                }
              </div>
            );
          })}
        </div>
        <div className="grow my-1 w-auto">
          <div className="flex flex-wrap justify-end items-end rounded text-black h-full md:pr-4 py-2">
            <div className="flex items-end">
              <div className="flex justify-center md:justify-start my-1 text-xs text-[#363538] max-[1600px]:text-smtext-sm mr-1 md:mr-4">
                <div className="bg-[#0694F3] scale-box mr-1 p-2 mr-2">
                </div>
                Moderate
              </div>
              <div className="flex justify-center md:justify-start my-1 text-xs text-[#363538] max-[1600px]:text-smtext-sm mr-1 md:mr-4">
                <div className="bg-[#FF8B20] scale-box 1r-2 p-2 mr-2">
                </div>
                Vigorous
              </div>
              <div className="flex justify-center md:justify-start my-1 text-xs text-[#363538] max-[1600px]:text-smtext-sm mr-1 md:mr-4">
                <div className="bg-[#F50F51] scale-box 1r-2 p-2 mr-2">
                </div>
                Peak
              </div>
            </div>
          </div>
        </div>
      </div>
    </div >
  );
};

export default Calendar;
